import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'
import {countries} from '../../lib/countries'

class Limits extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true,
        adFormCountries: []
    }

    componentDidMount(){
        this.setState({adFormCountries: countries})
    }

    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '20px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <div className="row" id="doc_integrations">
                                <div className="col">
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        Partner Limits
                                    </h2>
                                    <p>
                                        Every new partner with a free tier account will have some hard limits to reduce a possible service abuse. 

                                        <div className="alert alert-warning">All those limits can be increased contacting the support email <a href="mailto:admin@audiencerate.com">admin@audiencerate.com</a>.</div>


                                        <h3 style={{ marginTop: marginTopParagraph }} className="">
                                            License creation
                                        </h3>
                                        <p>
                                           Max new <b>10000 licenses created per account</b>. Reaching this limit will block the account to create new licenses.
                                        </p>
                                        <h3 style={{ marginTop: marginTopParagraph }} className="">
                                            Audience creation
                                        </h3>
                                        <p>
                                            Max new <b>10000 audiences created per account</b>. Reaching this limit will block the account to create new audiences.
                                        </p>
                                        <h3 style={{ marginTop: marginTopParagraph }} className="">
                                            File uploads
                                        </h3>
                                        <p>
                                            - Max <b>1TB uploaded per month</b> of uncompressed data (zipped files are counted for the uncompressed size processed). 
                                            If you hit this limit your account will be locked for the end of the remaining month and you cannot makes new uploads.<br/>
                                            - Max <b>400 daily uploads</b> per account. If you reach this limit your account will cannot make other new uploads for the rest of the day.
                                        </p>
                                       
                                    </p>
                                </div>
                            </div>

                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Limits)
